import accountComponents from "../../../../../web-sh/src/pages/admin/settings/components/account";

import DangerZone from "./DangerZone";
import PersonalInfo from "./PersonalInfo";
import Preferences from "./Preferences";

accountComponents.PersonalInfo = PersonalInfo;
accountComponents.Preferences = Preferences;
accountComponents.DangerZone = DangerZone;

export default accountComponents